import { memo, useCallback } from 'react';
import { Box, Button, Text } from '@betty/moonlight';
import { useNavigation } from '@betty/navigation';

function TimeoutCard() {
  const navigation = useNavigation();

  const handlePress = useCallback(() => {
    navigation.navigate('Timeout');
  }, [navigation]);

  return (
    <Box
      variant="outline-gradient"
      borderRadius="radius-200"
      borderWidth="border-width-050"
      gradient="borderAccent"
      padding="space-400"
      gap="space-400"
    >
      <Text
        variant="h5"
        locNS="responsibleGaming"
        locKey="selfExclusionTimeoutTitle"
        color="darkSurfacePrimary"
      />

      <Text
        variant="body-m-semi"
        locNS="responsibleGaming"
        locKey="selfExclusionTimeoutDescription"
        color="darkSurfacePrimary"
      />

      <Button
        variant="primary"
        locNS="responsibleGaming"
        locKey="selfExclusionTimeoutButton"
        onPress={handlePress}
      />
    </Box>
  );
}

export default memo(TimeoutCard);
